export default {
  states: [{
    value: 'Aguascalientes',
    label: 'Aguascalientes'
  }, {
    value: 'Baja California',
    label: 'Baja California'
  }, {
    value: 'Baja California Sur',
    label: 'Baja California Sur'
  }, {
    value: 'Campeche',
    label: 'Campeche'
  }, {
    value: 'Chiapas',
    label: 'Chiapas'
  },
  {
    value: 'Chihuahua',
    label: 'Chihuahua'
  },
  {
    value: 'Coahuila',
    label: 'Coahuila'
  },
  {
    value: 'Colima',
    label: 'Colima'
  },
  {
    value: 'Durango',
    label: 'Durango'
  },
  {
    value: 'Estado de México',
    label: 'Estado de México'
  },
  {
    value: 'Guanajuato',
    label: 'Guanajuato'
  },
  {
    value: 'Guerrero',
    label: 'Guerrero'
  },
  {
    value: 'Hidalgo',
    label: 'Hidalgo'
  },
  {
    value: 'Jalisco',
    label: 'Jalisco'
  },
  {
    value: 'Michoacán',
    label: 'Michoacán'
  },
  {
    value: 'Morelos',
    label: 'Morelos'
  },
  {
    value: 'Nayarit',
    label: 'Nayarit'
  },
  {
    value: 'Nuevo_Leon',
    label: 'Nuevo León'
  },
  {
    value: 'Oaxaca',
    label: 'Oaxaca'
  },
  {
    value: 'Puebla',
    label: 'Puebla'
  },
  {
    value: 'Querétaro',
    label: 'Querétaro'
  },
  {
    value: 'Quintana_Roo',
    label: 'Quintana Roo'
  },
  {
    value: 'San_Luis_Potosi',
    label: 'San Luis Potosí'
  },
  {
    value: 'Sinaloa',
    label: 'Sinaloa'
  },
  {
    value: 'Sonora',
    label: 'Sonora'
  },
  {
    value: 'Tabasco',
    label: 'Tabasco'
  },
  {
    value: 'Tamaulipas',
    label: 'Tamaulipas'
  },
  {
    value: 'Tlaxcala',
    label: 'Tlaxcala'
  },
  {
    value: 'Veracruz',
    label: 'Veracruz'
  },
  {
    value: 'Yucatán',
    label: 'Yucatán'
  },
  {
    value: 'Zacatecas',
    label: 'Zacatecas'
  }
  ]
}



// WEBPACK FOOTER //
// ./src/components/_shared/states/states.js